<div>
    <div>
        <img class="mx-auto d-block" src="" />
    </div>
    <form class="mt-4 ml-5 mr-5" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group ml-5 mr-5">
            <label for="oldPasswordInput">{{ "CHANGE_PASSWORD_COMPONENT_OLD_PASSWORD_LABEL" | translate }}</label>
            <input
                type="password"
                class="form-control"
                id="oldPasswordInput"
                aria-describedby="oldPasswordHelp"
                formControlName="oldPassword"
                autocomplete="current-password"
            />
        </div>
        <div class="form-group ml-5 mr-5">
            <label for="newPasswordInput">{{ "CHANGE_PASSWORD_COMPONENT_NEW_PASSWORD_LABEL" | translate }}</label>
            <input
                type="password"
                class="form-control"
                id="newPasswordInput"
                formControlName="newPassword"
                autocomplete="new-password"
            />
        </div>
        <div class="form-group ml-5 mr-5">
            <label for="confirmNewPasswordInput">{{
                "CHANGE_PASSWORD_COMPONENT_CONFIRM_NEW_PASSWORD_LABEL" | translate
            }}</label>
            <input
                type="password"
                class="form-control"
                id="confirmNewPasswordInput"
                formControlName="confirmNewPassword"
                autocomplete="new-password"
            />
        </div>
        <button class="btn w-100 py-1 mt-2">{{ "CHANGE_PASSWORD_COMPONENT_SUBMIT_BUTTON" | translate }}</button>
    </form>
    <hr />
</div>
